// extracted by mini-css-extract-plugin
export default {"ticket":"Idps5","firstTicket":"_2lk12","lastTicket":"vU9YU","color":"tJhC0"};